import React from "react";
import { FaGithub } from "react-icons/fa";
import { FiArrowUpRight } from "react-icons/fi";
import { useLanguage } from "../../context/LanguageContext";

const featuredProjects = [
  {
    title: "MoniMate AI Finance",
    en: "An offline-first finance app with AI receipt scanning, smart budgets, multi-wallet support, reports, and Google Drive sync.",
    id: "Aplikasi keuangan offline-first dengan pemindai struk AI, smart budget, multi-wallet, laporan, dan sinkronisasi Google Drive.",
    tech: ["Flutter", "GetX", "Hive", "Gemini", "ML Kit"],
    href: "https://github.com/zainalsalamun/moni_mate_flutter",
    accent: "green",
  },
  {
    title: "CV Craft AI",
    en: "An AI-powered CV builder with job matching, assisted writing, customizable templates, real-time preview, and PDF export.",
    id: "CV builder berbasis AI dengan job matching, penulisan berbantuan AI, template kustom, preview real-time, dan ekspor PDF.",
    tech: ["React", "TypeScript", "Supabase", "Gemini"],
    href: "https://github.com/zainalsalamun/cv-craft-ai",
    accent: "blue",
  },
  {
    title: "SehatKu HMS",
    en: "A multi-role hospital system for appointments, QR check-in, queues, medical records, prescriptions, and analytics.",
    id: "Sistem rumah sakit multi-role untuk appointment, QR check-in, antrean, rekam medis, resep, dan analytics.",
    tech: ["Flutter", "Riverpod", "GoRouter", "OpenAPI"],
    href: "https://github.com/zainalsalamun/sehatku_hms_mobile",
    accent: "coral",
  },
];

function CurrentFocus() {
  const { t } = useLanguage();

  return (
    <section className="current-focus" aria-labelledby="current-focus-title">
      <div>
        <span className="section-eyebrow">{t("about.currentFocusLabel")}</span>
        <h2 id="current-focus-title">{t("about.currentFocusTitle")}</h2>
        <p>{t("about.currentFocusBody")}</p>
      </div>

      <div className="current-focus-tags" aria-label={t("about.currentFocusLabel")}>
        {[
          "Flutter",
          "Android",
          "Clean Architecture",
          "BLoC / Cubit",
          "Offline-first",
          "AI Integration",
        ].map((item) => (
          <span key={item}>{item}</span>
        ))}
      </div>
    </section>
  );
}

function FeaturedGithubProjects() {
  const { language, t } = useLanguage();

  return (
    <section className="featured-github" aria-labelledby="featured-github-title">
      <div className="featured-github-heading">
        <div>
          <span className="section-eyebrow">{t("about.githubSelected")}</span>
          <h2 id="featured-github-title">{t("about.featuredRepos")}</h2>
        </div>
        <p>{t("about.featuredReposBody")}</p>
      </div>

      <div className="featured-repo-grid">
        {featuredProjects.map((project) => (
          <article
            className={`featured-repo-card featured-repo-${project.accent}`}
            key={project.title}
          >
            <div className="featured-repo-topline">
              <FaGithub aria-hidden="true" />
              <span>{t("about.openSource")}</span>
            </div>
            <h3>{project.title}</h3>
            <p>{project[language]}</p>
            <div className="featured-repo-tech">
              {project.tech.map((item) => (
                <span key={item}>{item}</span>
              ))}
            </div>
            <a href={project.href} target="_blank" rel="noopener noreferrer">
              {t("about.viewRepository")}
              <FiArrowUpRight aria-hidden="true" />
            </a>
          </article>
        ))}
      </div>
    </section>
  );
}

export { CurrentFocus, FeaturedGithubProjects };
